import { useI18n } from '@muse/i18n'

import { usePromoAnalytics } from '@core/analytics'
import { ROUTES } from '@core/routes'
import { getAuthorInsightsPageUrl } from '@features/author'
import { useHydratedCurrentUser } from '@features/session'

import { InsightsPromoBanner } from '../components/insights-promo-banner/InsightsPromoBanner'
import { INSIGHTS_PROMO_COPY } from '../constants/insightsPromoCopy'

export type TInsightsPromoBannerContainerProps = {
    variant?: 'rounded' | 'flush'
}

export const InsightsPromoBannerContainer = ({
    variant,
}: TInsightsPromoBannerContainerProps = {}) => {
    const { t } = useI18n()
    const { isAuthenticated, username } = useHydratedCurrentUser()

    const { ref, handleClick } = usePromoAnalytics<HTMLElement>({
        viewEvent: { name: 'insights_promo_view', payload: {} },
        clickEvent: { name: 'insights_promo_click', payload: {} },
    })

    const ctaHref =
        isAuthenticated && username ? getAuthorInsightsPageUrl({ username }) : ROUTES.insights

    return (
        <InsightsPromoBanner
            ref={ref}
            title={t(INSIGHTS_PROMO_COPY.titleKey)}
            description={t(INSIGHTS_PROMO_COPY.descriptionKey)}
            ctaLabel={t(INSIGHTS_PROMO_COPY.ctaKey)}
            ctaHref={ctaHref}
            imageAlt={t(INSIGHTS_PROMO_COPY.imageAltKey)}
            onCtaClick={handleClick}
            variant={variant}
        />
    )
}
